import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";

function CloseBtn({ closeFn }) {
  return (
    <div
      style={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }}
    >
      <AiFillCloseCircle size={20} onClick={() => closeFn()} />
    </div>
  );
}

export default CloseBtn;
